import { render } from "./UseHTMLString.vue?vue&type=template&id=7caba938"
import script from "./UseHTMLString.vue?vue&type=script&lang=js"
export * from "./UseHTMLString.vue?vue&type=script&lang=js"
script.render = render

export default script